// extracted by mini-css-extract-plugin
module.exports = {"FranchiseNewsroom":"FranchiseNewsroom_FranchiseNewsroom__PyWs6"};